export const themeOptionFactory = (theme) => ({
  components: {
    EmKidAndFamilyPage: {
      styleOverrides: {
        title: {
          fontSize: "14px",
          fontWeight: 400,
          textTransform: "uppercase",
        },
        sectionHeader: {
          marginBottom: theme.spacing(2),
        },
        occupantCardsContainer: {
          marginLeft: theme.spacing(-3),
          marginRight: theme.spacing(-3),
          padding: theme.spacing(1, 3, 0),
          position: "relative",
          display: "grid",
          gridAutoFlow: "column",
          gridTemplateRows: "repeat(3, minmax(0, 1fr))",
          gap: theme.spacing(2),
          overflowX: "auto",
          "::-webkit-scrollbar": {
            display: "none",
          },
          marginBottom: theme.spacing(5),
        },
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(175px, 1fr))",
          justifyItems: "center",
          gap: theme.spacing(1),
          "@media (max-width: 400px)": {
            gridTemplateColumns: "repeat(auto-fill, minmax(145px, 1fr))",
          },
        },
        gridItem: {
          "& .OccupantImageCard-contentContainer": {
            padding: theme.spacing(0.5, 1),
          },
        },
        occupantCardWrapper: {
          width: "245px",
          height: "80px",
        },
        eventPromotionSection: {
          display: "flex",
          gap: theme.spacing(2.5),
          overflowY: "scroll",
          "::-webkit-scrollbar": {
            display: "none",
          },
          padding: theme.spacing(1, 0),
          height: 326,
        },
        eventPromotionCardWrapper: {
          flex: "0 0 180px",
          "& .MuiCard-root": {
            minHeight: 0,
            minWidth: 0,
            height: "100%",
            width: "100%",
          },
          "& .MuiCardMedia-img": {
            height: "auto",
            aspectRatio: "1",
          },
        },
      },
    },
    KidsAndFamilyOccupantCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          display: "flex",
          height: "100%",
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
          "& .MuiTypography-root": {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
          },
          "&.section-card": {
            border: "1px solid transparent",
            background:
              "linear-gradient(181deg, rgba(255, 250, 237, 0.44) 10.64%, rgba(217, 195, 142, 0.44) 158.34%) padding-box, linear-gradient(white, white) padding-box, linear-gradient(to right, #FFFAED, #D9C38E) border-box",
            backgroundClip: "padding-box, padding-box, border-box",
            ".KidsAndFamilyOccupantCard-levelContainer": {
              backgroundColor: theme.palette.primary.dark,
            },
            ".KidsAndFamilyOccupantCard-titleContainer": {
              borderBottom: "none",
            },
          },
        },
        occupantLogo: {
          boxShadow: theme.shadows[1],
          minWidth: "80px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "100%",
          },
          "& .MuiAvatar-img": {
            objectFit: "contain",
          },
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          "& .MuiTypography-root": {
            lineHeight: 1.25,
          },
        },
        levelContainer: {
          background: "#A4A4AD",
          padding: theme.spacing(0.5, 1),
          color: theme.palette.common.white,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "20px 0px 0px 0px",
        },
        venueLogo: {
          width: "100%",
          objectFit: "contain",
        },
        venueLogoContainer: {
          display: "flex",
          alignItems: "center",
          flex: 1,
        },
        titleContainer: {
          flex: "3",
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        titleText: {
          fontSize: "0.875rem",
          fontWeight: 400,
          textTransform: "uppercase",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
        },
        categoryText: {
          fontSize: "0.625rem",
          fontWeight: 400,
          color: theme.palette.text.secondary,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
          overflow: "hidden",
        },
        occupantIdentityContainer: {
          display: "flex",
          height: "100%",
          padding: theme.spacing(0.5, 0.875, 0),
          gap: theme.spacing(0.875),
          flex: 1.4,
        },
        occupantDetailWrapper: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "flex-end",
          flex: "1",
        },
        occupantDetailContainer: {
          height: "100%",
          display: "flex",
          justifyContent: "space-between",
        },
        categoryDetailContainer: {
          display: "flex",
          alignItems: "center",
          paddingLeft: theme.spacing(0.875),
        },
        levelContainerWrapper: {
          height: "100%",
          display: "flex",
          alignItems: "end",
          "& .MuiTypography-root": {
            fontSize: "0.875rem",
          },
        },
      },
    },
  },
})
